import { Box, TableCell } from '@mui/material';
import { GridCellProps } from '@progress/kendo-react-grid';
import moment from 'moment';
import * as React from 'react';

import { useDateCellStyles } from './dateCellStyles';

export const DateCell = ({ dataItem, rowType }: GridCellProps) => {
  const sxStyles = useDateCellStyles();

  if (rowType !== 'data') {
    return null;
  }

  return (
    <TableCell sx={sxStyles.dataCell}>
      <Box sx={sxStyles.text}>
        {dataItem.originalStartDate &&
          moment(dataItem.originalStartDate).format('L')}
      </Box>
    </TableCell>
  );
};
